export enum FactorStatus {
  //ثبت سفارش
  SUBMIT = "SUBMIT",
  //در انتظار پرداخت
  PENDING_PAYMENT = "PENDING_PAYMENT",
  //بررسی و تایید سفارش
  PROGRESSING = "PROGRESSING",
  //در حال آماده سازی
  PREPARATION = "PREPARATION",
  //خروج از آشپزخانه
  PROCESSING_CENTER = "PROCESSING_CENTER",
  //تحویل به مأمور ارسال
  DELIVERY_DISPATCHER = "DELIVERY_DISPATCHER",
  //تحویل به مشتری
  DELIVERED = "DELIVERED",
  //لغو شده
  CANCELED = "CANCELED",
  //لغو شده توسط سیستم
  CANCELED_BY_SYSTEM = "CANCELED_BY_SYSTEM"
}

export class FactorStatusHelper {
  static getStatusText(status: string): string {
    switch (status?.toUpperCase()) {
      case FactorStatus.SUBMIT:
        return 'SUBMIT';
      case FactorStatus.PENDING_PAYMENT:
        return 'PENDING_PAYMENT';
      case FactorStatus.PROGRESSING:
        return 'PROGRESSING';
      case FactorStatus.PREPARATION:
        return 'PREPARATION';
      case FactorStatus.PROCESSING_CENTER:
        return 'PROCESSING_CENTER';
      case FactorStatus.DELIVERY_DISPATCHER:
        return 'DELIVERY_DISPATCHER';
      case FactorStatus.DELIVERED:
        return 'DELIVERED';
      case FactorStatus.CANCELED:
        return 'Canceled';
      case FactorStatus.CANCELED_BY_SYSTEM:
        return 'CanceledBySystem';
      default:
        return 'Unknown';
    }
  }

  static getStatusColor(status: string): string {
    switch (status?.toUpperCase()) {
      case FactorStatus.SUBMIT:
        return '#2196f3'; // آبی
      case FactorStatus.PENDING_PAYMENT:
        return '#ff9800'; // نارنجی
      case FactorStatus.PROGRESSING:
        return '#9c27b0'; // بنفش
      case FactorStatus.PREPARATION:
        return '#607d8b'; // خاکستری آبی
      case FactorStatus.PROCESSING_CENTER:
        return '#ff5722'; // نارنجی تیره
      case FactorStatus.DELIVERY_DISPATCHER:
        return '#795548'; // قهوه ای
      case FactorStatus.DELIVERED:
        return '#4caf50'; // سبز
      case FactorStatus.CANCELED:
      case FactorStatus.CANCELED_BY_SYSTEM:
        return '#f44336'; // قرمز
      default:
        return '#9e9e9e'; // خاکستری
    }
  }

  static getStatusIcon(status: string): string {
    switch (status?.toUpperCase()) {
      case FactorStatus.SUBMIT:
        return 'add_square';
      case FactorStatus.PENDING_PAYMENT:
        return 'payment';
      case FactorStatus.PROGRESSING:
        return 'check_circle';
      case FactorStatus.PREPARATION:
        return 'restaurant';
      case FactorStatus.PROCESSING_CENTER:
        return 'exit_to_app';
      case FactorStatus.DELIVERY_DISPATCHER:
        return 'local_shipping';
      case FactorStatus.DELIVERED:
        return 'done_all';
      case FactorStatus.CANCELED:
      case FactorStatus.CANCELED_BY_SYSTEM:
        return 'cancel';
      default:
        return 'help';
    }
  }
}
